/**
 * @fileoverview gRPC-Web generated client stub for core.private.products
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from "grpc-web";

import {
  DeleteProductRequest,
  DeleteProductResponse} from "./products_pb";

export class ProductsServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options["format"] = "text";

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoDeleteProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    DeleteProductResponse,
    (request: DeleteProductRequest) => {
      return request.serializeBinary();
    },
    DeleteProductResponse.deserializeBinary
  );

  deleteProduct(
    request: DeleteProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DeleteProductResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/core.private.products.ProductsService/DeleteProduct",
      request,
      metadata || {},
      this.methodInfoDeleteProduct,
      callback);
  }

}

